import { __assign, __rest } from "tslib";
import React from 'react';
import { omitBy } from 'lodash';
import { toPx } from '../../utils/to-px';
import { toSafeColor } from '../../utils/to-safe-color';
import { SectionItem } from '../section-item';
import { useRemainingWidth, WidthProvider } from '../width-context';
export function Column(_a) {
    var siblingsCount = _a.siblingsCount, _b = _a.direction, direction = _b === void 0 ? 'ltr' : _b, _c = _a.verticalAlign, verticalAlign = _c === void 0 ? 'top' : _c, rest = __rest(_a, ["siblingsCount", "direction", "verticalAlign"]);
    var props = __assign(__assign({}, rest), { verticalAlign: verticalAlign });
    var classesName = 'mj-outlook-group-fix';
    if (props.cssClass) {
        classesName += " ".concat(props.cssClass);
    }
    var remainingWidth = useRemainingWidth({
        width: props.width,
        round: props.forceWidth,
    });
    return (React.createElement(WidthProvider, { value: remainingWidth },
        React.createElement(SectionItem, { verticalAlign: verticalAlign },
            React.createElement("div", { className: classesName, style: {
                    fontSize: '0px',
                    textAlign: 'left',
                    direction: direction,
                    display: 'inline-block',
                    verticalAlign: verticalAlign,
                    width: props.forceWidth ? props.width : '100%',
                    maxWidth: props.width,
                } }, hasGutter(props) ? (React.createElement(RenderGutter, __assign({}, props))) : (React.createElement(RenderColumn, __assign({}, props)))))));
}
function RenderGutter(props) {
    var backgroundColor = props.backgroundColor, border = props.border, borderRadius = props.borderRadius, padding = props.padding, paddingBottom = props.paddingBottom, paddingLeft = props.paddingLeft, paddingRight = props.paddingRight, paddingTop = props.paddingTop, verticalAlign = props.verticalAlign;
    var remainingWidth = useRemainingWidth({
        padding: padding,
        paddingLeft: paddingLeft,
        paddingRight: paddingRight,
        border: border,
    });
    var style = __assign({ backgroundColor: toSafeColor(backgroundColor), border: border, borderRadius: toPx(borderRadius), verticalAlign: verticalAlign }, omitBy({
        padding: padding,
        paddingTop: paddingTop,
        paddingRight: paddingRight,
        paddingBottom: paddingBottom,
        paddingLeft: paddingLeft,
    }, function (value) { return !value; }));
    return (React.createElement("table", { border: "0", cellPadding: 0, cellSpacing: 0, role: "presentation", width: "100%" },
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("td", { style: style },
                    React.createElement(WidthProvider, { value: remainingWidth },
                        React.createElement(RenderColumn, __assign({}, props))))))));
}
function RenderColumn(props) {
    var innerBackgroundColor = props.innerBackgroundColor, backgroundColor = props.backgroundColor, border = props.border, borderRadius = props.borderRadius, verticalAlign = props.verticalAlign, children = props.children;
    var remainingWidth = useRemainingWidth({
        border: border,
    });
    var withGutter = hasGutter(props);
    return (React.createElement("table", { border: "0", cellPadding: 0, cellSpacing: 0, role: "presentation", style: withGutter
            ? { backgroundColor: toSafeColor(innerBackgroundColor) }
            : {
                backgroundColor: toSafeColor(backgroundColor),
                border: border,
                borderRadius: toPx(borderRadius),
                verticalAlign: verticalAlign,
            }, width: "100%" },
        React.createElement("tbody", null, withGutter ? (children) : (React.createElement(WidthProvider, { value: remainingWidth }, children)))));
}
function hasGutter(props) {
    return [
        props.paddingLeft,
        props.paddingRight,
        props.paddingTop,
        props.paddingBottom,
        props.padding,
    ].some(function (_) { return _ !== null && _ !== undefined; });
}
//# sourceMappingURL=column.js.map